import {Dropdown, IDropdownOption, IDropdownStyles} from '@fluentui/react';
import React from "react";


const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 70 }
};
const options: IDropdownOption[] = [
    { key: 'yes', text: 'Yes' },
    { key: 'no', text: 'No' }
];

class PersonalData extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {editable: true}
    }

    onChange(e,v)
    {
        this.props.onUpdate('gdpr', v.key==='yes');
    }

    render() {
        return (
            <div style={{width:'100%', height: '40px', position:'relative', marginTop:'20px'}}>
                <span> Personal Data: </span>
                <div className="dropdown">
                    <Dropdown
                        onChange={this.onChange.bind(this)}
                        disabled={this.props.disabled || this.props.isreadonly}
                        selectedKey={this.props.gdpr? 'yes' : 'no'}
                        options={options}
                        styles={dropdownStyles}
                    />
                </div>
            </div>
        );
    }
}
export default PersonalData;






// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/PersonalData.js